import {HTTP_INTERCEPTORS} from '@angular/common/http';

import {ErrorInterceptor} from "./error-interceptor";
import {AuthInterceptor} from "./auth.interceptor";
import {ClockSkewInterceptor} from "./clock-skew.interceptor";

export const HttpInterceptorProviders = [
  {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
  {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
  {provide: HTTP_INTERCEPTORS, useClass: ClockSkewInterceptor, multi: true},
];
